// these mirror values in _constants.scss

export const MAX_MOBILE = 767

export const languageCodes = ['en', 'mi', 'zh-hans']
export const categorySlugs = ['houses', 'apartments', 'commercial', 'terrace-housing', 'multi-residential', 'master-planning', 'in-progress']



// WEBPACK FOOTER //
// ./assets/j/src/constants.js